import { ChangeStep } from './changeModalSteps';
import { ChangeForm } from './hooks/useChangeForm';

export function canAdvanceFromStep(step: ChangeStep, form: ChangeForm): boolean {
  switch (step) {
    case 'Timing':
      if (form.values.timing === null) {
        form.setFieldError('timing', 'Please choose when the change should apply');
        return false;
      }
      return true;
    case 'Reservation Handling':
      if (form.values.reservationChoice === null) {
        form.setFieldError('reservationChoice', 'Please choose how to handle reservations');
        return false;
      }
      return true;
    case 'Review':
      return true;
    default:
      return true;
  }
}
